import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { PagesList } from '../../react-elements/pages-list';
import { render_tab } from '../cool-settings-dialog';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { SmallUiContent } from './small-ui-content';
function SettingSmallInterfaceImpl(props) {
    const { pages, tabs, selected_tab_key, dirty, loading, onSave, onSelectTab, volatile_data, onChangeState, } = props;
    const selected_tab = useMemo(() => tabs.find((tab) => selected_tab_key === tab.key), [tabs, selected_tab_key]);
    return (_jsx(SmallUiContent, { left_list: _jsx(PagesList, { dividers: true, chevrons: true, pages: pages, changeSelectedTab: onSelectTab }), page: _jsx(Box, { className: "AppGridMobile DialogMobileFooter", flexDirection: "column", flexWrap: "nowrap", m: 2, children: _jsx("div", { className: " AppGridMobileContent", children: _jsx(ErrorBoundary, { children: selected_tab != null
                        ? render_tab(selected_tab, volatile_data, onChangeState)
                        : null }) }) }), dirty: dirty, loading: loading, onSave: onSave, changeSelectedTab: onSelectTab, selectedTab: selected_tab_key }));
}
export const SettingSmallInterface = memo(SettingSmallInterfaceImpl);
